// src/components/PeoplePlan/Tables/ShiftLeadersTable.js
import React from "react";
import GenericEmployeeTable from "../EmployeeManagement/GenericEmployeeTable";
import { ROLE_CONFIGS } from "../configs/roleConfigs";

function ShiftLeadersTable({ selectedMUM, storeData, onNavigateToProfile }) {
  return (
    <GenericEmployeeTable
      selectedMUM={selectedMUM}
      storeData={storeData}
      roleConfig={ROLE_CONFIGS.SHIFT_LEADER}
      onNavigateToProfile={onNavigateToProfile}
      enableSorting={false}
    />
  );
}

export default ShiftLeadersTable;
